import React, { useState, useEffect, useRef } from "react";
import { Row, Col, Breadcrumb, Card, Form, Badge } from "react-bootstrap";

const About = () => {
    return (
    <>
        About us
    </>
  );
};

export default About;